export default __webpack_public_path__ + "static/media/visitsCircle.1f9e8d60.png";